var map = {
	"./activeOrder.svg": "6cb7",
	"./add.png": "ac8f",
	"./adding.svg": "82f0",
	"./assets.svg": "1c4e",
	"./bottom-red-line.png": "2bda",
	"./cancel.png": "0a5c",
	"./chat.png": "b140",
	"./dashboard.svg": "af50",
	"./exite.png": "64a1",
	"./falseAuth.png": "88dd",
	"./fee.svg": "b293",
	"./green-line.png": "7281",
	"./history.svg": "479b",
	"./notification.png": "672b",
	"./number.png": "1f08",
	"./numberOfTrade.svg": "5a96",
	"./ok.png": "281e",
	"./orders.svg": "5887",
	"./percent.png": "9fb4",
	"./portfolio.svg": "416d",
	"./profile.svg": "5958",
	"./refrral.svg": "aec2",
	"./restore.png": "bd61",
	"./setting.svg": "61e4",
	"./tick.png": "1ce1",
	"./top-red-line.png": "9452",
	"./trueAuth.png": "dcd1",
	"./uploadgreen.png": "187b",
	"./uploadred.png": "6959",
	"./usergreen.png": "f811",
	"./userred.png": "ee49",
	"./wallet.png": "466b",
	"./walletgreen.png": "df84",
	"./walletred.png": "4283"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7d66";